import {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import styles from "./index.module.scss";

function InputButton({title, button, onClick}) {
  const intl = useIntl();
  const [name, setName] = useState(null);
  const [groupName, setGroupName] = useState(null);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{<FormattedMessage id="ID_CODE_COMPLETE" />}</h3>
      <p className={styles.contents}>
        <FormattedMessage
          id="ID_CODE_COMPLETE_CONTENT"
          values={{
            mission: <span className={styles.mission}>{title}</span>,
          }}
        />
      </p>

      <div className={styles.input_box}>
        <input
          className={styles.input}
          placeholder={intl.formatMessage({id: "ID_NAME_ENTER"})}
          onChange={({target}) => setName(target.value)}
        />
        <input
          className={styles.input}
          placeholder={intl.formatMessage({id: "ID_CLASS_ENTER"})}
          onChange={({target}) => setGroupName(target.value)}
        />
      </div>

      <div className={styles.btn_box}>
        <button className={styles.check} type="button" disabled={!name && !groupName} onClick={() => onClick(name, groupName)}>
          <FormattedMessage id={button} />
        </button>
      </div>
    </div>
  );
}

export default InputButton;
